import styled from "styled-components";

export const Projects = styled.div`
color: white;
font-size: 20px;
display: flex;
position: relative;
flex-wrap: wrap;
justify-content: center;
max-width: 700px;
gap: 2rem 2rem;
`;

// gap -> vertical horizontal
// 330 W -> 230 H

export const Tile = styled.div`
max-width: 330px;
max-height: 230px;
border-radius: 15px;
overflow: hidden;

img {
    width: auto;
    height: 100%;
}
`;